export default {
  waitlist: {},
  detailView: {
    loading: true,
  },
};
